export const companySelector = state => state.addCompany;